// @ts-nocheck
import { gql } from "@apollo/client";
import * as Types from "../../../__generated__/schema.graphql.types";
import { AppointmentServiceProviderBasicInfoFragmentDoc } from "../../queries/appointment/appointmentServiceProviderBasicInfo.graphql.types";

export type AppointmentServicesFragment = {
  __typename?: "appointment";
  appointmentServices: Array<{
    __typename?: "AppointmentService";
    id: string;
    price: string;
    providerId?: string | null;
    startTime?: string | null;
    endTime?: string | null;
    serviceMenuItemId: string;
    serviceMenuItem: {
      __typename?: "MedspaServiceMenuItem";
      id: string;
      name: string;
    };
    provider?: {
      __typename?: "userMedspa";
      id: string;
      color?: string | null;
      initials?: string | null;
      user: {
        __typename?: "user";
        id: string;
        firstName: string;
        lastName: string;
      };
    } | null;
  }>;
};

export type AppointmentInvoiceFragment = {
  __typename?: "appointment";
  invoice?: { __typename?: "invoice"; id: string; status: string } | null;
};

export const AppointmentServicesFragmentDoc = gql`
  fragment AppointmentServices on appointment {
    appointmentServices(orderBy: { startTime: ASC }) {
      id
      price
      providerId
      startTime
      endTime
      serviceMenuItemId
      serviceMenuItem {
        id
        name
      }
      ...AppointmentServiceProviderBasicInfo
    }
  }
  ${AppointmentServiceProviderBasicInfoFragmentDoc}
`;
export const AppointmentInvoiceFragmentDoc = gql`
  fragment AppointmentInvoice on appointment {
    invoice {
      id
      status
    }
  }
`;
